// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ui-tab--reset-padding[data-v-577ba764] {\n\tpadding-left: 0;\n\tpadding-right: 0;\n\tpadding-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
